import gql from 'graphql-tag';
import { FULL_MOMENT_FRAGMENT } from 'graphql/fragment/momentFragment';

export const DETAIL_QUERY = gql`
    query DetailQuery($worldMapId: String!, $storyId: String!, $token: String, $language: String) {
        moment: publishedStory(
            worldMapId: $worldMapId
            storyId: $storyId
            token: $token
            language: $language
        ) {
            ...FFullMoment
        }
    }

    ${FULL_MOMENT_FRAGMENT}
`;

export const BOOKING_QUERY_VIEW = gql`
    query BookingQueryView($worldMapId: String!, $worldMapMarkerId: String!) {
        worldMarkerBookingConfiguration(
            worldMapId: $worldMapId
            worldMapMarkerId: $worldMapMarkerId
        ) {
            bookingConfigurationId
            fields {
                fieldId
                title
                type
                validation {
                    required
                }
            }
        }

        worldMapMarker(worldMapId: $worldMapId, worldMapMarkerId: $worldMapMarkerId) {
            worldMapMarkerId
            hasBookingConfiguration
            isBookingAvailable
        }
    }
`;

export const BOOKING_QUERY_EDITOR = gql`
    query BookingQueryEditor($worldMapId: String!, $worldMapMarkerId: String!, $token: String) {
        worldMarkerBookingConfiguration(
            worldMapId: $worldMapId
            worldMapMarkerId: $worldMapMarkerId
            token: $token
        ) {
            bookingConfigurationId
            fields {
                fieldId
                title
                type
                validation {
                    required
                }
            }
        }
        worldMarkerBookingDetails(
            worldMapId: $worldMapId
            worldMapMarkerId: $worldMapMarkerId
            token: $token
        ) {
            worldMapBookingId
            data
            timeCreated
            timeUpdated
        }
    }
`;
